import { render, staticRenderFns } from "./phigros_render.vue?vue&type=template&id=26d25a86&"
import script from "./phigros_render.vue?vue&type=script&lang=ts&"
export * from "./phigros_render.vue?vue&type=script&lang=ts&"
import style0 from "./phigros_render.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports